import { MutationTuple, useMutation } from '@apollo/client';

import { evictCache } from '../apollo';
import {
  DeleteAccountingSyncEventForFiscalYearMutation,
  DeleteAccountingSyncEventForFiscalYearMutationVariables,
  DELETE_ACCOUNTING_SYNC_EVENT_FOR_FISCAL_YEAR,
  GET_FISCAL_YEAR,
} from '../graphql';

type UseDeleteAccountingSyncEventForFiscalYear = MutationTuple<
  DeleteAccountingSyncEventForFiscalYearMutation,
  DeleteAccountingSyncEventForFiscalYearMutationVariables
>;

export const useDeleteAccountingSyncEventForFiscalYear = (
  fiscalYearId: string,
): UseDeleteAccountingSyncEventForFiscalYear =>
  useMutation<DeleteAccountingSyncEventForFiscalYearMutation, DeleteAccountingSyncEventForFiscalYearMutationVariables>(
    DELETE_ACCOUNTING_SYNC_EVENT_FOR_FISCAL_YEAR,
    {
      refetchQueries: [
        {
          query: GET_FISCAL_YEAR,
          variables: {
            fiscalYearId,
          },
        },
      ],
      awaitRefetchQueries: true,
      update: (cache) => {
        evictCache(cache, ['getAccountingExpense', 'getAccountingQres', 'getAccountingQreSummary']);
      },
    },
  );
